import { render, staticRenderFns } from "./HolidayWork.vue?vue&type=template&id=13ffe072&scoped=true&"
import script from "./HolidayWork.vue?vue&type=script&lang=js&"
export * from "./HolidayWork.vue?vue&type=script&lang=js&"
import style0 from "./HolidayWork.vue?vue&type=style&index=0&id=13ffe072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ffe072",
  null
  
)

export default component.exports